var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewfinderPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1DE77CD5-B0BD-47F0-BE8D-E65585AAC609") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-investment-attributes",
    transform: "translate(-364.000000, -259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes",
    transform: "translate(145.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/performance",
    transform: "translate(60.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.296296, 13.333333)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#9DD47D",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4545629,9.46586382 L18.8129072,18.1503415 C18.5221684,18.3251986 18.2314296,18.5583601 17.9988385,18.791503 C16.7777541,20.132093 16.8940124,22.1720742 18.2314296,23.3961674 C19.5688468,24.6202606 21.604,24.5036146 22.825196,23.1630246 L34.8618764,9.9320749 C34.9200241,9.81550348 34.9781719,9.69893206 34.8618764,9.58236064 C34.8034681,9.40757811 34.570877,9.40757811 34.4545629,9.46586382 Z",
    id: "Shape",
    fill: "#FFFFFF",
    transform: "translate(26.040130, 16.838412) rotate(10.000000) translate(-26.040130, -16.838412) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16596897,16.1284041 C8.09160985,10.5393555 13.8125642,6.48554722 20.5701118,6.48554722 C26.0309569,6.48554722 30.8148624,9.13285654 33.4659676,13.09835",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 4.44444444,
    strokeDasharray: "0.8888888597488404,2.666666793823242",
    fillRule: "nonzero",
    transform: "translate(20.165968, 11.485547) rotate(2.000000) translate(-20.165968, -11.485547) "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinderPerformance);
export default __webpack_public_path__ + "static/media/viewfinder_performance.962a0eb8588a5bdbd6146e7ab4da17f0.svg";
export { ForwardRef as ReactComponent };